/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["quick-panel{display:flex;flex-direction:column;flex:1 1 auto;width:280px;min-width:280px;max-width:280px;z-index:99}quick-panel .mat-slide-toggle-content{flex:1}.cqbadge{position:absolute;top:10px;left:35%;font-size:11px;line-height:13px;border-radius:50%;width:20px;height:20px;background-color:#d81919;border:4px solid #d81919;color:#fff;text-align:center}.cqbutton{font-size:12px;line-height:12px;border-radius:50%;width:17px;height:17px;background-color:#d81919;border:4px solid #d81919;color:#fff;text-align:center;cursor:pointer}"];
export { styles as styles };
